/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { threadsControllerCreate } from "./threadsControllerCreate";
import { threadsControllerDelete } from "./threadsControllerDelete";
import { threadsControllerFindAll } from "./threadsControllerFindAll";
import { threadsControllerFindOne } from "./threadsControllerFindOne";
import { threadsControllerUpdate } from "./threadsControllerUpdate";
import { threadSharesControllerCreate } from "./threadSharesControllerCreate";

export function threadsService() {
  return { threadsControllerCreate, threadsControllerFindAll, threadsControllerFindOne, threadsControllerUpdate, threadsControllerDelete, threadSharesControllerCreate }
}